module.exports = __webpack_public_path__ + "static/1_EP-a307d6e953d6837c04f33425a11e0417.svg";